import { isElement, forEach } from 'lodash';
import mustache from 'mustache';

import containerManager from '../../01-helpers/filter-context/container-manager';
import { get as getPageOptions } from '../../01-helpers/utilities/options';
import { stringToNode } from '../../01-helpers/utilities/node';
import { subscribe } from '../../01-helpers/event-manager';

import { FILTERAPI_FAILED } from '../../02-const/event-names';

import { GoogleAnalyticsDataLayer } from '../../05-domain/google-analytics/data-layer';

const moduleName = 'filter-results',
    selectors = {
        base: `.js-${moduleName}`,
        container: `.js-${moduleName}-container`,
        resultItemTemplate: '#resultItemTemplate'
    },
    translationsKey = {
        key: 'translations',
        title: 'NoResultTitle',
        body: 'NoResultBody',
        error: 'Error'
    },
    template = {
        loading: `<div class="c-loader-container"><div class="c-loader"></div></div>`,
        noResults: `<li><h2>{{ title }}</h2><p>{{ body }}</p></li>`
    };

function renderTemplate(template, item) {
    return mustache.render(template, item);
}

export class FilterResults {

    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._configure(baseElement);
        this._setup();
    }

    _showFaultMessage() {
        const errorMessage = this.translations[translationsKey.error];
        this.resultContainer.innerHTML = `<li>${errorMessage}</li >`;
    }


    _configure(baseElement) {
        this.baseElement = baseElement;
        this.filterContext = containerManager.getContainer();
        this.resultContainer = this.baseElement.querySelector(selectors.container);
    }

    _setup() {
        this.translations = getPageOptions(translationsKey.key);
        this.bindEvents.call(this);
    }

    bindEvents() {
        this.filterContext.onBeforeUpdate(() => {
            this.resultContainer.appendChild(stringToNode(template.loading));
        });

        this.filterContext.onUpdate(({ currentState }) => {

            // check if there is a response from webservice
            if (currentState.response) {
                const response = currentState.response,
                    items = response.Items,
                    resultContainer = this.baseElement.querySelector(selectors.container),
                    resultTemplate = this.baseElement.querySelector(
                        selectors.resultItemTemplate
                    ).innerHTML;

                resultContainer.innerHTML = '';

                forEach(items, (item) => {
                    const htmlElement = stringToNode(renderTemplate(resultTemplate, item));
                    resultContainer.appendChild(htmlElement);
                });

                if (items.length === 0) {
                    // no results, so show the correct message
                    const htmlElement = stringToNode(renderTemplate(template.noResults,
                        {
                            title: this.translations[translationsKey.title],
                            body: this.translations[translationsKey.body]
                        }
                    ));

                    resultContainer.appendChild(htmlElement);
                }

                forEach(this.resultContainer.children, (item) => {
                    new GoogleAnalyticsDataLayer(item);
                })
            }
        });

        subscribe(FILTERAPI_FAILED, this._showFaultMessage.bind(this));

    };
}

/* ========================================================================== */

const initFilterResults = () => {
    forEach(document.querySelectorAll(selectors.base), (resultsElement) => {
        new FilterResults(resultsElement);
    });
};

initFilterResults();
